// src/components/WarRoomActionsDesk.js
//
// SECTION 532 (2026-09-30): the action items a War Room occasion gave THIS account, on his desk until they are
// done. The query is the one the read rule can prove (ownerUid == me). Done items fold away; nothing is deleted.
import React, { useEffect, useMemo, useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { sortActions, isOverdue } from '../data/warRoom';
import { ActionRow } from './WarRoomRecord';

const C = { panel: '#0B1626', line: '#2E4A6B', dim: '#8AA4BF', accent: '#E8A020', bad: '#E06C6C', ok: '#5FB878', text: '#DCE7F2' };

export default function WarRoomActionsDesk({ user }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    if (!user || !user.uid) return undefined;
    const q = query(collection(db, 'warRoomActions'), where('ownerUid', '==', user.uid));
    const unsub = onSnapshot(q, snap => { setRows(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setErr(''); },
      e => { setErr('Action items could not be read: ' + (e && e.code ? e.code : e.message)); setRows([]); });
    return () => unsub();
  }, [user && user.uid]);
  const all = useMemo(() => sortActions(rows || []), [rows]);
  const open = all.filter(a => a.status !== 'done');
  const done = all.filter(a => a.status === 'done');
  const late = open.filter(a => isOverdue(a)).length;
  if (rows && rows.length === 0 && !err) return null;   // nothing assigned: the desk stays quiet
  return (
    <div style={{ border: '1px solid ' + (late ? C.bad : open.length ? C.accent : C.line), background: C.panel, marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '10px 14px', borderBottom: '1px solid ' + C.line }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>War Room - action items assigned to you</div>
          <div style={{ fontSize: 11, color: C.dim, marginTop: 2 }}>Given to you at a War Room occasion. They stay here until you mark them done.</div>
        </div>
        <div style={{ fontSize: 12, fontWeight: 700, color: late ? C.bad : open.length ? C.accent : C.ok, whiteSpace: 'nowrap' }}>{rows === null ? '…' : open.length + ' open' + (late ? ', ' + late + ' overdue' : '')}</div>
      </div>
      <div style={{ padding: '4px 14px 10px' }}>
        {err ? <div style={{ color: C.bad, fontSize: 12 }}>&#9888; {err}</div> : null}
        {open.map(a => <ActionRow key={a.id} a={a} user={user} showOccasion />)}
        {done.length ? <details><summary style={{ cursor: 'pointer', fontSize: 12, color: C.dim, marginTop: 6 }}>{done.length} done</summary>{done.map(a => <ActionRow key={a.id} a={a} user={user} showOccasion />)}</details> : null}
      </div>
    </div>
  );
}
